"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailQuotesClass = exports.emailContainerClass = void 0;
exports.emailContainerClass = 'titan-decoded-email-container';
exports.emailQuotesClass = 'titan-decoded-email-container-quotes';
//# sourceMappingURL=email-markup-constants.js.map